import { ILocalAuthPolicyResult } from '../../../ServerApi/requests/GetLocalAuthConfigurationRequest';
import { IPasswordPolicy, PolicyNames } from './IPasswordPolicy';
import { MaximumPasswordLengthPolicy } from './MaximumPasswordLengthPolicy';
import { MinimumPasswordLengthPolicy } from './MinimumPasswordLengthPolicy';
import { MustContainLettersPolicy } from './MustContainLettersPolicy';
import { MustContainNumbersPolicy } from './MustContainNumbersPolicy';
import { MustContainSymbolsPolicy } from './MustContainSymbolsPolicy';
import { MustContainUppercaseLettersPolicy } from './MustContainUppercaseLettersPolicy';

export class LocalAuthConfiguration {
    private activePasswordPolicies: Map<PolicyNames, IPasswordPolicy> = new Map();
    private minLength: number = 0;
    private maxLength: number = 0;

    public getActivePasswordPolicies(): Map<PolicyNames, IPasswordPolicy> {
        return this.activePasswordPolicies;
    }

    public getMinPasswordLength(): number {
        return this.minLength;
    }

    public getMaxPasswordLength(): number {
        return this.maxLength;
    }

    public static loadServerConfig(response: ILocalAuthPolicyResult): LocalAuthConfiguration {
        const config = new LocalAuthConfiguration();
        if (response.isMustContainLettersPolicyEnabled) {
            config.activePasswordPolicies.set(PolicyNames.MustContainLetters, MustContainLettersPolicy.getPolicy());
        }
        if (response.isMustContainNumbersPolicyEnabled) {
            config.activePasswordPolicies.set(PolicyNames.MustContainNumbers, MustContainNumbersPolicy.getPolicy());
        }
        if (response.isMustContainSymbolsPolicyEnabled) {
            config.activePasswordPolicies.set(PolicyNames.MustContainSymbols, MustContainSymbolsPolicy.getPolicy());
        }
        if (response.isMustContainUppercasePolicyEnabled) {
            config.activePasswordPolicies.set(PolicyNames.MustContainUppercaseLetters,
                MustContainUppercaseLettersPolicy.getPolicy());
        }
        if (response.isMinimumPasswordLengthPolicyEnabled && response.minimumPasswordLength > 0) {
            config.activePasswordPolicies.set(PolicyNames.MinimumPasswordLength,
                new MinimumPasswordLengthPolicy(response.minimumPasswordLength));
            config.minLength = response.minimumPasswordLength;
        }
        if (response.isMaximumPasswordLengthPolicyEnabled && response.maximumPasswordLength > 0) {
            config.activePasswordPolicies.set(PolicyNames.MaximumPasswordLength,
                new MaximumPasswordLengthPolicy(response.maximumPasswordLength));
            config.maxLength = response.maximumPasswordLength;
        }
        return config;
    }

    public static default(): LocalAuthConfiguration {
        return new LocalAuthConfiguration();
    }
}
